var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13727 3L5.84301 1.29426C6.05233 1.08494 6.05233 0.745568 5.84301 0.53608L5.46392 0.156989C5.2546 -0.0523295 4.91523 -0.0523295 4.70574 0.156989L3 1.86273L1.29426 0.156989C1.08494 -0.0523295 0.745568 -0.0523295 0.53608 0.156989L0.156989 0.53608C-0.0523295 0.745398 -0.0523295 1.08477 0.156989 1.29426L1.86273 3L0.156989 4.70574C-0.0523295 4.91506 -0.0523295 5.25443 0.156989 5.46392L0.53608 5.84301C0.745398 6.05233 1.08494 6.05233 1.29426 5.84301L3 4.13727L4.70574 5.84301C4.91506 6.05233 5.2546 6.05233 5.46392 5.84301L5.84301 5.46392C6.05233 5.2546 6.05233 4.91523 5.84301 4.70574L4.13727 3Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.bcc33cc79f70003e928b3bb5fa237740.svg";
export { ForwardRef as ReactComponent };